<template>
  <div class="no-data" style="background-color: #1E1C1D; text-align: center; padding: 10px; height: 300px">
    <span style="font-size: 15px; font-weight: bold; color: #fff">{{ title }}</span>
    <div>
      <p style="height: 30px; line-height: 30px; font-size: 20px; color: #3c3d3c">nodata</p>
      <Icon type="md-analytics" size="180" style="color: #3c3d3c;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'nodata_300_h',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
